export default __webpack_public_path__ + "static/soup_light-d76524a39e9f929c7c9c16684fa0b635.svg";